import { canonical } from "@/common/functions";

export default function() {
	return {
		link: [canonical(this.$route)],
	};
}
